import apiClient from '../../../services/apiClient';
import { showErrorToast } from '../../../utils/toastHelper';

export const loginUser = async (email, password) => {
  try {
    const response = await apiClient.post('/auth/login', { email, password });
    console.log('data', response);
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message);
    // throw new Error(error);
    return error;
  }
};

export const logoutUser = async () => {
  try {
    const response = await apiClient.post('/logout');
    console.log('data', response);
    return response.data;
  } catch (error) {
    console.error('Logout failed');
    showErrorToast(error?.message);
  }
};

export const fetchUser = async (token) => {
  try {
    const response = await apiClient.get('/user');
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message);
    return error;
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await apiClient.delete('/user/' + id);
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message);
    return error;
  }
};
export const updateUserProfile = async (formData) => {
  try {
    const response = await apiClient.post('/user/profile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message);
    return error;
  }
};

export const changePassword = async (data) => {
  try {
    const response = await apiClient.post('/auth/change-password', data);
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message);
    return error;
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await apiClient.post('/auth/forgot-password', { email });
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message);
    return error;
  }
};

export const resetPassword = async (data) => {
  try {
    const response = await apiClient.post('/auth/reset-password', data);
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message);
    return error;
  }
};
